import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

const MyListingsSpaceBanner = ({ bannerObject }) => {
  const {
    icon,
    header,
    body,
    button,
    background,
    headerClass = ''
  } = bannerObject;

  if (isEmpty(bannerObject)) return null;

  return (
    <div className={classnames('MyListingsSpaceBanner flex middle column-sm', background)}>
      { icon &&
        <div className="margin-lg-right icon-container hidden-xs hidden-sm">
          <img src={`/web-hosting/assets/images/${icon}.svg?v=rb`} alt={icon} />
        </div>
      }
      <div className="body-container">
        <div className={classnames('heavy margin-md-bottom', headerClass)}>{header}</div>
        <div className="margin-xl-right">
          {body}
        </div>
      </div>
      {
        button &&
        <div className="button-container block-xs-left">
          <a
            className="btn btn-primary"
            href={button.href}
          >
            {button.title}
          </a>
        </div>
      }
    </div>
  );
};

MyListingsSpaceBanner.propTypes = {
  bannerObject: PropTypes.object
};

export default MyListingsSpaceBanner;
